import React from 'react'
import {Navigate, Route, Routes, Outlet} from 'react-router-dom'
import {GeneralDataOFLoginUser} from '../../../Utils/Auth'
import {AuthenticateUser} from '../../../Utils/_helpers/RoleAndPermission'
import {AdminAccountHeader} from './AdminAccountsHeader'
import {Overview} from './Overview/Overview'
import {Settings} from './Settings'
import StaffAccountList from './Staff_Account/StaffAccountList'
import NotificationList from '../../UserPages/accounts/Notifications/list'
import Affiliate from './Affiliate'
// import Commission from './Commision'
import ApprovalNotifications from './ApprovalNotifications'
import Commission from './Staff_Account/StaffProfileDetail/Commision'

const AccountsPage_Admin = () => {
  return (
    <>
      <Routes>
        <Route
          element={
            <>
              <AdminAccountHeader />
              <Outlet />
            </>
          }
        >
          <Route index element={<Navigate to='/accounts/overview' replace={true} />} />

          <Route
            path='overview'
            element={
              <>
                <Overview />
              </>
            }
          />
          {GeneralDataOFLoginUser()?.role !== 'superAdmin' && (
            <Route
              path='settings'
              element={
                <>
                  <Settings />
                </>
              }
            />
          )}
          {GeneralDataOFLoginUser()?.role !== 'superAdmin' && (
            <Route
              path='affiliate'
              element={
                <>
                  <Affiliate />
                </>
              }
            />
          )}
          {GeneralDataOFLoginUser()?.role !== 'superAdmin' && (
            <Route
              path='commission'
              element={
                <>
                  <Commission />
                </>
              }
            />
          )}
          {AuthenticateUser('staffs-list') && (
            <Route
              path='staff-account'
              element={<>{AuthenticateUser('staffs-list') && <StaffAccountList />}</>}
            />
          )}

          <Route
            path='notifications'
            element={
              <>
                <NotificationList />
              </>
            }
          />

          <Route
            path='approvals'
            element={
              <>
                <ApprovalNotifications />
              </>
            }
          />
        </Route>
      </Routes>
    </>
  )
}

export default AccountsPage_Admin
